import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { clone } from 'lodash';
import { Subscription } from 'rxjs';

import { MedicalHistoryService } from '../patients/medical-history.service';
import { parseErrors } from '../shared/api.service';

@Component({
  selector: 'facesheet',
  templateUrl: 'facesheet.component.html',
  styleUrls: ['./facesheet.component.scss']
})

export class FacesheetComponent implements OnInit {
  @Input() visit;
  errors = [];
  loading = false;
  medicalHistoryReq: Subscription;
  savingMedicalHistory = false;
  historyReq;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private medicalHistoryService: MedicalHistoryService,
  ) { }

  ngOnInit() { }

  submit() {
    this.loading = true;
    if (this.historyReq) { this.historyReq.unsubscribe(); }
    let model = clone(this.visit.medicalHistory);
    model = Object.assign(model, {
      historyReviewedVisit: this.visit.id,
      historyReviewed: this.visit.historyReviewed
    });
    this.historyReq = this.medicalHistoryService.save(model).subscribe(medicalHistory => {
      this.visit.medicalHistory = medicalHistory;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  toggleIcon(medication) {
    medication.active = !medication.active;
    let medicalHistory = this.visit.medicalHistory;

    this.savingMedicalHistory = true
    if (this.medicalHistoryReq) { this.medicalHistoryReq.unsubscribe(); }
    this.medicalHistoryReq = this.medicalHistoryService.save(medicalHistory).subscribe(() => {
      this.savingMedicalHistory = false;
    }, err => {
      this.errors = [err];
      this.savingMedicalHistory = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/visits/facesheet.component.ts